import { Stack, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2";
import NoneImage from "../icons/NonImage.png"
import { useSovet } from "../hooks/useSovet"; 

const SovetPage = () => {
    const { sovet: allSovet, loading, error } = useSovet();
    return (
        <>
            <Typography variant="h1">ОБЩЕСТВЕННЫЙ СОВЕТ</Typography>

            <Grid container columnSpacing={5} rowSpacing={7} style={{ marginLeft: '-20px', marginRight: '-20px' }}>
                {
                // items.sort((a, b) => a.fio.localeCompare(b.fio))
                allSovet
                    .map(item => (
                        <Grid
                            lg={4}
                            md={4}
                            sm={6}
                            xs={6}
                            key={item.fio}
                        >
                            <Stack spacing={2}>
                                {!item.foto
                                    ? <img src={NoneImage} alt={item.fio} />
                                    : <img src={item.foto} alt={item.fio}
                                        style={{
                                            // height: '280px',
                                            maxHeight: '280px',
                                            objectFit: 'contain',
                                        }}
                                    />
                                }
                                <Typography variant="body2" sx={{ pt: 2 }}>{item.fio}</Typography>
                                <Typography variant="body3">{item.description}</Typography>
                            </Stack>
                        </Grid>
                    ))}
            </Grid>
        </>
    )
}

export default SovetPage
